/**
 * created by lzy 2020.08.31
 * 新闻日历管理批量导入第一步
 */
'use strict';
angular.module('calendarBulkImportModule', []).controller('calendarBulkImportCtrl', ['$scope', '$modalInstance', '$sessionStorage', 'modalDialog', 'trsHttpService',
    function($scope,  $modalInstance, $sessionStorage, modalDialog, trsHttpService) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         *
         * @return  {[type]}   [return description]
         */
        function initStatus() {

        };
        
        /**
         * [initData description] 初始化数据
         *
         * @return  {[type]}   [return description]
         */
        function initData() {
            $scope.data = {}
        }

        /**
         * [upload description] 上传文件
         *
         * @param  {[type]}  files   [files description]
         *
         * @return  {[type]}   [return description]
         */
        $scope.upload = function(files) {
            const reg = /^.*\.(?:xlsx)$/i;//文件名可以带空格
            if (reg.test(files[0].name)) {//校验不通过
                $scope.data.file = files[0];
            } else {
                modalDialog.alertType('请选择xlsx格式文件', '', 'warning', false);
            }
        }

        /**
         * [deleteFile description]删除上传的文件
         *
         * @return  {[type]}   [return description]
         */
        $scope.deleteFile = function() {
            $scope.data.file = undefined;
        }
        /**
         * [confirm description] 开始上传按钮
         *
         * @return  {[type]}   [return description]
         */
        $scope.confirm = function() {
            var curUserInfo = $sessionStorage.get('curUserInfo');
            var options = {
                method: 'POST',
                url: '/message/daily/excelparse',
                contentType: undefined,
                transformRequest: function (data) {
                    var formData = new FormData();
                    for (var a in data) {
                        formData.append(a, data[a]);
                    }
                    return formData;
                }
            }
            $scope.loadingPromise = trsHttpService.httpServerForMR(options, {
                tenantid: curUserInfo.TENANTID,
                userId: curUserInfo.ID,
                file: $scope.data.file
            }).then((data) => {
                $modalInstance.close(data);
            })
        }

        /**
         * [close description] 取消按钮
         *
         * @return  {[type]}   [return description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        }
    }
])